module.exports = __webpack_public_path__ + "85187c1fa27fecdaa30a8efe2036b887.svg";